<div *ngIf="appInfo$ | async as appInfo">
  <div class="flex flex-col items-center justify-center text-center p-4">
    <img
      class="h-24 w-24 rounded-2xl shadow p-[10px] m-4 bg-white"
      [attr.src]="'/assets/images/softapps-logo.svg'"
    />
    <h6 class="w-full font-semibold">SoftApps</h6>
  </div>
  <div class="soft-card mt-4">
    <div class="soft-overline">Anwendungs Informationen</div>
    <div class="text-sm mt-4">
      <span class="font-semibold">{{ '#APPLICATION.APP_INFO.NAME' | translate }}:</span>
      {{ appInfo.name }}
    </div>
    <div class="text-sm">
      <span class="font-semibold">{{ '#APPLICATION.APP_INFO.ID' | translate }}:</span>
      {{ appInfo.id }}
    </div>
    <div class="text-sm">
      <span class="font-semibold"
        >{{ '#APPLICATION.APP_INFO.VERSION' | translate }}:</span
      >
      {{ appInfo.version }}
    </div>
    <div class="text-sm mt-4" id="copyright">&copy; Softline IT GmbH 1980-{{ year }}</div>
  </div>
</div>
